module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-CV.87fe12ff.png";